export const SET_LOADING = "app/ui/SET_LOADING";
export const SET_ERRORS = "app/ui/SET_ERRORS";
export const SET_RESPONSE = "app/ui/SET_RESPONSE";
export const CLEAR_ERRORS = "app/ui/CLEAR_ERRORS";
export const CLEAR_LOADING = "app/ui/CLEAR_LOADING";
export const CLEAR_RESPONSE = "app/ui/CLEAR_RESPONSE";
export const CLEAR_ALL = "app/ui/CLEAR_ALL";
